module.exports = __webpack_public_path__ + "static/media/step2.e22d9f98.png";